import * as React from 'react';
import { isAfter } from 'date-fns';
import toast from 'react-hot-toast';
import { useUnreadNotifications } from 'hooks/useUnreadNotifications';
import NotificationToast from './components/NotificationToast';

const TOAST_DURATION_MS = 10_000;

/** Toasts notifications that arrive while the viewer is on the site; the backlog stays in the bell. */
export default function NewNotificationToasts() {
  const { unread } = useUnreadNotifications({ isPolling: true });
  const since = React.useRef(new Date());

  React.useEffect(() => {
    const arrived = unread
      .filter((notification) => isAfter(new Date(notification.createdAt), since.current))
      .reverse();
    if (arrived.length === 0) {
      return;
    }
    arrived.forEach((notification) =>
      toast.custom(
        (t) => (
          <NotificationToast
            notification={notification}
            isVisible={t.visible}
            onDismiss={() => toast.dismiss(t.id)}
          />
        ),
        { id: notification.id, duration: TOAST_DURATION_MS },
      ),
    );
    since.current = new Date(arrived[arrived.length - 1].createdAt);
  }, [unread]);

  return null;
}
